import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MessageStatusMC from './MessageStatusMC';

const CallPermissionReplyMessageMC = ({ message, conversation }) => {
  const { t } = useTranslation();

  const messageText = useMemo(() => {
    const { response, isPermanent } = message.contentCallPermissionReply || {};
    const normalizedResponse = `${response || ''}`.toLowerCase();
    const isAcceptedResponse = ['accepted', 'accept', 'acepted'].includes(normalizedResponse);
    let messageKey = 'call_permission_reply.not_accepted';

    if (isAcceptedResponse) {
      messageKey = isPermanent === true
        ? 'call_permission_reply.accepted_permanent'
        : 'call_permission_reply.accepted_temporary';
    }

    return t(messageKey);
  }, [message.contentCallPermissionReply, t]);

  return (
    <div className="text-pre-line fs-md-and-down-12">
      {messageText && <div>{messageText}</div>}
      <MessageStatusMC message={message} platform={conversation.platform} />
    </div>
  );
};

export default CallPermissionReplyMessageMC;
